import IFrame from './IFrame';

export default IFrame;
